import styles from "./styles";
import { Translate } from "../Translate";

export const successContent = (text: string, additionalText?: string | null) => (
  <styles.Container>
    <styles.SuccessIcon />
    <styles.Description>
      <styles.Title>{text}</styles.Title>
      {additionalText && <styles.SubTitle>{additionalText}</styles.SubTitle>}
    </styles.Description>
  </styles.Container>
);

export const errorContent = (text: string, href?: string) => (
  <styles.Container>
    <styles.ErrorIcon />
    <styles.Description $error>
      <styles.Title>{text}</styles.Title>
      {href && (
        <styles.Link href={href} target="_blank" rel="noreferrer">
          <Translate value="toast.openTransaction" />
        </styles.Link>
      )}
    </styles.Description>
  </styles.Container>
);
